module.exports = __webpack_public_path__ + "static/media/select-arrow.16e94ab3.svg";